import axios from 'axios';
import _get from 'lodash/get';
import { isUnauthenticatedResponse, triggerSessionExpired } from './helpers';
const URL =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? process.env.REACT_APP_BACKEND_URL
    : window.location.origin + '/api/';
                                                              
export default function api() {
  const axiosInstance = axios.create({
    baseURL: URL,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': '69420',
    },
    withCredentials: true,
  });

  const ResponseBody = (response) => {
    try {
      const responseData = response?.data ?? {};
      const transformedResponse =
        responseData && typeof responseData === 'object' ? { ...responseData } : responseData ?? {};

      if (
        transformedResponse &&
        typeof transformedResponse === 'object' &&
        isUnauthenticatedResponse(transformedResponse)
      ) {
        triggerSessionExpired();
      }
      return transformedResponse;
    } catch (error) {
      console.warn('Error transforming response:', error);
      return {};
    }
  };

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const statusCode = _get(error, 'response.status', '');
        const errorResponse = error?.response ?? {};

        if (statusCode === 401) {
          triggerSessionExpired();
        }

        const errorData = errorResponse?.data;
        if (errorData && typeof errorData === 'object' && isUnauthenticatedResponse(errorData)) {
          triggerSessionExpired();
        }

        return errorResponse;
      } catch (interceptorError) {
        console.warn('Error in response interceptor:', interceptorError);
        return {};
      }
    }
  );

  return {
    get: (url, config) => axiosInstance.get(url, config).then(ResponseBody),
    post: (url, data, config) => axiosInstance.post(url, data, config).then(ResponseBody),
    put: (url, data, config) => axiosInstance.put(url, data, config).then(ResponseBody),
    delete: (url, config) => axiosInstance.delete(url, config).then(ResponseBody),
  };
}

export function wihoutPrefix() {
  const axiosInstance = axios.create({
    baseURL: URL,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Cache-Control': 'no cache',
    },
    withCredentials: true,
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      try {
        const cookies = response?.headers?.['Set-Cookie'];
        if (cookies && Array.isArray(cookies)) {
          axiosInstance.defaults.headers['Cookie'] = cookies.join(';');
        }
        const responseData = response?.data;
        if (
          responseData &&
          typeof responseData === 'object' &&
          isUnauthenticatedResponse(responseData)
        ) {
          triggerSessionExpired();
        }
        return response;
      } catch (error) {
        console.warn('Error in response interceptor:', error);
        return response ?? {};
      }
    },
    (error) => {
      try {
        const statusCode = error?.response?.status ?? '';
        if (statusCode === 401) {
          triggerSessionExpired();
        }
        const errorData = error?.response?.data;
        if (errorData && typeof errorData === 'object' && isUnauthenticatedResponse(errorData)) {
          triggerSessionExpired();
        }
        return Promise.reject(error);
      } catch (interceptorError) {
        console.warn('Error in error interceptor:', interceptorError);
        return Promise.reject(error);
      }
    }
  );

  return {
    get: (url, data) => axiosInstance.get(url, data),
    post: (url, data, config) => axiosInstance.post(url, data, config),
    put: (url, data, config) => axiosInstance.put(url, data, config),
    delete: (url, config) => axiosInstance.delete(url, config),
  };
}

export function authorizedApi(token) {
  const axiosInstance = axios.create({
    baseURL: URL,
    headers: {
      Authorization: 'Bearer ' + token,
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': '69420',
    },
    withCredentials: true,
  });

  const ResponseBody = (response) => {
    try {
      const responseData = response?.data ?? {};
      const transformedResponse =
        responseData && typeof responseData === 'object' ? { ...responseData } : responseData ?? {};

      if (
        transformedResponse &&
        typeof transformedResponse === 'object' &&
        isUnauthenticatedResponse(transformedResponse)
      ) {
        triggerSessionExpired();
      }
      return transformedResponse;
    } catch (error) {
      console.warn('Error transforming response:', error);
      return {};
    }
  };

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const statusCode = _get(error, 'response.status', '');
        const errorResponse = error?.response ?? {};

        if (statusCode === 401) {
          triggerSessionExpired();
        }

        const errorData = errorResponse?.data;
        if (errorData && typeof errorData === 'object' && isUnauthenticatedResponse(errorData)) {
          triggerSessionExpired();
        }

        return errorResponse;
      } catch (interceptorError) {
        console.warn('Error in response interceptor:', interceptorError);
        return {};
      }
    }
  );

  return {
    get: (url, config) => axiosInstance.get(url, config).then(ResponseBody),
    post: (url, data, config) => axiosInstance.post(url, data, config).then(ResponseBody),
    put: (url, data, config) => axiosInstance.put(url, data, config).then(ResponseBody),
    delete: (url, config) => axiosInstance.delete(url, config).then(ResponseBody),
  };
}
